import { Box } from '@mui/material';
import { FC } from 'react';
import { useLocation } from 'react-router';
import { MenuElement } from '.';
import { PageMenuItem } from './item';
import { PageMenuElementList } from './list';

type Props = MenuElement;

export const PageMenuElement: FC<Props> = ({
  isActive,
  title,
  config,
  link,
  onClick,
  disabled,
  icon,
  secondaryIcon,
  isBaseLevel,
  tooltip,
  hasTodo
}) => {
  const location = useLocation();
  const menuEntryIsActive = isActive?.(location) ?? false;

  return (
    <>
      <PageMenuItem
        title={title}
        link={link}
        onClick={onClick}
        isActive={menuEntryIsActive}
        childrenConfig={config}
        icon={icon}
        secondaryIcon={secondaryIcon}
        disabled={disabled}
        isBaseLevel={isBaseLevel}
        tooltip={tooltip}
        hasTodo={hasTodo}
      />

      {config && menuEntryIsActive && (
        <Box marginBottom="2rem">
          <PageMenuElementList
            elements={config.map((c) => {
              return { ...c, isBaseLevel: false };
            })}
          />
        </Box>
      )}
    </>
  );
};
